import { FC, useCallback, useContext } from 'react'
import { useSelector } from 'react-redux'
import { ScreenContext } from 'react-components'
import { useAppDispatch } from '../../../../redux/hooks'
import { useTranslation } from '../../../../hooks/locale'
import { getCurrentOpenedFilterModal, popModal, pushModal } from '../../../../redux/filters'
import { FilterModalType } from '../../filter-sort-section/types'
import SmartSearchModal from '../smart-search-modal'
import AiAvatar from '../ai-avatar'
import { PillButton } from './styles'

const SmartSearchPill: FC = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { isMobile } = useContext(ScreenContext)
    const currentOpenedFilterModal = useSelector(getCurrentOpenedFilterModal)

    const handleSheetToggle = useCallback(() => {
        if (currentOpenedFilterModal === FilterModalType.SMART_SEARCH) {
            dispatch(popModal())
        } else {
            dispatch(pushModal(FilterModalType.SMART_SEARCH))
        }
    }, [currentOpenedFilterModal, dispatch])

    const handleClick = useCallback(() => {
        if (isMobile) {
            handleSheetToggle()
            return
        }

        if (currentOpenedFilterModal !== FilterModalType.FILTERS) {
            dispatch(pushModal(FilterModalType.FILTERS))
        }
    }, [currentOpenedFilterModal, dispatch, handleSheetToggle, isMobile])

    return (
        <>
            <PillButton type="button" onClick={handleClick}>
                <AiAvatar size="small" />
                {t('smartSearch.pillLabel')}
            </PillButton>

            {isMobile && <SmartSearchModal handleModalToggle={handleSheetToggle} />}
        </>
    )
}

export default SmartSearchPill
